/* eslint-disable react-hooks/exhaustive-deps */
import {
  EditOutlined,
  ArrowUpOutlined,
  PlusOutlined,
  DeleteOutlined,
} from "@ant-design/icons";
import { Table, Button, message, Modal, Input } from "antd";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { animateScroll as scroll } from "react-scroll";
import { apiClient } from "../Api/AllApi";

import "../Styles/ListPages.css";

const GetCategory = () => {
  const { t, i18n } = useTranslation();
  const [searchText, setSearchText] = useState("");
  const [dataSource, setDataSource] = useState([]);
  const [loading, setLoading] = useState(false);
  const [deleteItemId, setDeleteItemId] = useState(null);
  const [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false);

  useEffect(() => {
    fetchCategories();
  }, [i18n.language]);

  const fetchCategories = async () => {
    setLoading(true);
    try {
      const response = await apiClient.get("/categories");
      const categoriesData = response.data.map(item => {
        let nameObj = { en: "N/A", ar: "N/A" };
        try {
          nameObj = item.name ? JSON.parse(item.name) : { en: "N/A", ar: "N/A" };
        } catch (error) {
          console.warn("Error parsing name:", error);
        }

        return {
          key: item.id,
          id: item.id,
          name: nameObj[i18n.language] || nameObj.en || "N/A",
          description: item.description || "-",
          status: item.status || "inactive",
        };
      });
      setDataSource(categoriesData);
    } catch (err) {
      message.error(t("Failed to fetch categories"));
    }
    setLoading(false);
  };

  // Delete item
  const handleDelete = (id) => {
    setDeleteItemId(id);
    setIsDeleteModalVisible(true);
  };

  const handleConfirmedDelete = async () => {
    try {
      await apiClient.delete(`/categories/${deleteItemId}`);
      message.success(t("Category deleted successfully"));
      fetchCategories();
    } catch (error) {
      message.error(t("Failed to delete category"));
    } finally {
      setIsDeleteModalVisible(false);
      setDeleteItemId(null);
    }
  };

  const handleCancelDelete = () => {
    setIsDeleteModalVisible(false);
    setDeleteItemId(null);
  };

  const filteredData = dataSource.filter((item) =>
    item.name.toLowerCase().includes(searchText.toLowerCase())
  );

  const columns = [
    {
      title: "#",
      key: "index",
      render: (_, __, index) => index + 1,
      width: 60,
    },
    {
      title: t("Name"),
      dataIndex: "name",
      key: "name",
    },
    {
      title: t("Description"),
      dataIndex: "description",
      key: "description",
    },
    {
      title: t("Status"),
      dataIndex: "status",
      key: "status",
      render: (status) => (
        <span style={{ 
          color: status === 'active' ? '#52c41a' : '#ff4d4f',
          fontWeight: 'bold'
        }}>
          {t(status)}
        </span>
      )
    },
    {
      title: t("Actions"),
      key: "actions",
      width: 150,
      render: (_, record) => (
        <div style={{ display: "flex", gap: "8px" }}>
          <Link to={`/categories/update/${record.id}`}>
            <Button
              type="primary"
              icon={<EditOutlined />}
              style={{ backgroundColor: "#1890ff" }}
            >
              {t("Edit")}
            </Button>
          </Link>
          <Button
            danger
            icon={<DeleteOutlined />}
            onClick={() => handleDelete(record.id)}
          >
            {t("Delete")}
          </Button>
        </div>
      ),
    },
  ];

  return (
    <div className="list-page" style={{ padding: "24px" }}>
      <div
        style={{
          marginBottom: "16px",
          display: "flex",
          alignItems: "center",
        }}
      >
        <Input.Search
          placeholder={t("Search categories")}
          allowClear
          onChange={(e) => setSearchText(e.target.value)}
          style={{ width: 300 }}
        />
      </div>

      <Table
        loading={loading}
        dataSource={filteredData}
        columns={columns}
        pagination={{ position: ["bottomCenter"] }}
        scroll={{ x: 800 }}
      />      <div style={{ position: "fixed", right: "50px", bottom: "50px", zIndex: 1000, display: "flex", gap: "16px" }}>
        <Link to="/categories/add">
          <Button
            type="primary"
            shape="circle"
            icon={<PlusOutlined />}
            size="large"
            style={{ backgroundColor: "#52c41a" }}
          />
        </Link>
        <Button
          type="primary"
          shape="circle"
          icon={<ArrowUpOutlined />}
          size="large"
          onClick={() => scroll.scrollToTop()}
        />
      </div>

      <Modal
        title={t("Confirm Delete")}
        open={isDeleteModalVisible}
        onOk={handleConfirmedDelete}
        onCancel={handleCancelDelete}
        okText={t("Yes")}
        cancelText={t("No")}
        okButtonProps={{ danger: true }}
      >
        <p>{t("Are you sure you want to delete this category?")}</p>
      </Modal>
    </div>
  );
};

export default GetCategory;
